// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, STATE_NAME_SELECT_TAG } from './select-tag.reducer';

const currentState = createFeatureSelector<State>(STATE_NAME_SELECT_TAG);

export const selectTagListResponse = createSelector(
  currentState,
  (state: State) => state.response,
);

export const selectTagListError = createSelector(
  currentState,
  (state: State) => state.responseError,
);

export const selectTagListShowSkeleton = createSelector(
  currentState,
  (state: State) => state.responseLoading,
);


